import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_knight-dashboard-2/artifacts/d4gjpsyz_KCCV-NoBg.png";

// The supplied PNG is already background-removed (transparent).
// Both header and footer instances get a soft ground-glow halo under
// the wordmark. Header = subtle golden glow. Footer = brighter white halo.
const Logo = ({ variant = "dark", compact = false, height }) => {
  const isLight = variant === "light";
  const h = height || (compact ? 44 : 56);

  const groundGlow = isLight
    ? "radial-gradient(ellipse at center, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.5) 35%, rgba(255,255,255,0) 78%)"
    : "radial-gradient(ellipse at center, rgba(244,180,0,0.55) 0%, rgba(244,180,0,0.2) 40%, rgba(244,180,0,0) 78%)";

  return (
    <div className="relative flex items-center select-none" aria-label="Knight Credit Consultants">
      {/* Ground-glow halo positioned underneath the logo */}
      <span
        aria-hidden="true"
        className={`absolute left-1/2 -translate-x-1/2 pointer-events-none rounded-full ${isLight ? "bottom-[-18px] w-[110%] h-8 blur-xl" : "bottom-[-12px] w-[95%] h-5 blur-lg"}`}
        style={{ background: groundGlow }}
      />
      <img
        src={LOGO_URL}
        alt="Knight Credit Consultants"
        style={{ height: h }}
        className="relative w-auto object-contain"
        draggable={false}
      />
    </div>
  );
};

export default Logo;
